// Partner Portal Authentication (11 Oct 2026, AIDC-11146): one file, keyed by collection handle.
// Each club page has its own password and its own session key, so one club's login does not open the other's.
// The template puts the handle in data-club on #partner-login. Only salted SHA-256 hashes are stored here (salt = "<handle>:"), not the passwords.
// This is a speed bump on the page, not server-side security: the products themselves are still reachable by direct URL.

const CLUB_HASHES = {
  'partners-cfc': 'c8dc6f4bca87da1a70bb20c4a25963bffc09befbf859d113993a26cfebfef88b',
  'partners-allez': 'cf5850503a82a576c8f45d7d15602669f68900706094d465d52f86c601c94a71'
};
const SESSION_HOURS = 4;

function clubHandle() {
  const el = document.getElementById('partner-login');
  return el ? el.getAttribute('data-club') : null;
}

async function sha256Hex(text) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
}

// Check session on page load
document.addEventListener('DOMContentLoaded', function() {
  const club = clubHandle();
  if (!club) return;
  const hasAccess = sessionStorage.getItem('partner_access_' + club);
  const accessTime = parseInt(sessionStorage.getItem('partner_time_' + club) || '0');
  const sessionTimeout = SESSION_HOURS * 60 * 60 * 1000;

  // If valid session for THIS club, show content
  if (hasAccess === 'true' && (Date.now() - accessTime < sessionTimeout)) {
    showContent();
  }

  // Enter key support
  const passwordInput = document.getElementById('password-input');
  if (passwordInput) {
    passwordInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        checkPassword();
      }
    });
  }
});

async function checkPassword() {
  const club = clubHandle();
  const input = document.getElementById('password-input');
  const errorMsg = document.getElementById('error-msg');
  const expected = club ? CLUB_HASHES[club] : null;
  const given = expected ? await sha256Hex(club + ':' + input.value) : null;

  if (expected && given === expected) {
    sessionStorage.setItem('partner_access_' + club, 'true');
    sessionStorage.setItem('partner_time_' + club, Date.now());
    showContent();
  } else {
    errorMsg.style.display = 'block';
    input.value = '';
    input.focus();
    setTimeout(() => errorMsg.style.display = 'none', 3000);
  }
}

function showContent() {
  document.getElementById('partner-login').classList.add('hidden');
  document.getElementById('partner-content').classList.add('visible');
}

function logout() {
  const club = clubHandle();
  if (club) {
    sessionStorage.removeItem('partner_access_' + club);
    sessionStorage.removeItem('partner_time_' + club);
  }
  location.reload();
}
